import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../../../core/config/api-endpoints.constants';
import { createCatalogueStore } from '../../catalogue/catalogue-store.util';
import type { CatalogueStore } from '../../catalogue/catalogue.types';
import { Bullet, BulletCreate, BulletUpdate } from '../models/bullet.model';

@Injectable({ providedIn: 'root' })
export class BulletStoreService implements CatalogueStore<Bullet, BulletCreate, BulletUpdate> {
  private readonly store = createCatalogueStore<Bullet, BulletCreate, BulletUpdate>({
    endpoint: API_ENDPOINTS.bullets,
    uploadPath: '/api/bullets/upload_image',
  });

  bulletsResource = this.store.resource;
  items = this.store.items;
  loading = this.store.loading;
  error = this.store.error;
  byId = this.store.byId;
  reload = this.store.reload;
  create = this.store.create;
  update = this.store.update;
  remove = this.store.remove;
  uploadImage = this.store.uploadImage;
}
